// src/components/student/ArchivedStudents.jsx
import React from 'react';
import { Archive } from 'lucide-react';
import { useStudentContext } from '../../contexts/StudentContext';
import { unarchiveStudent } from '../../services/studentService';
import { styles } from '../../styles/theme';

const ArchivedStudents = ({ onBack }) => {
  const { getArchivedStudents } = useStudentContext();
  const archivedStudents = getArchivedStudents();

  const handleUnarchive = async (studentId, studentName) => {
    const confirmed = window.confirm(
      `Restore ${studentName}?\n\nThis will move them back to the active student list.`
    );
    
    if (!confirmed) return;

    try {
      await unarchiveStudent(studentId);
      alert('✅ Student restored successfully!');
    } catch (error) {
      console.error('Error unarchiving student:', error);
      alert('❌ Failed to restore student. Please try again.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.centerContainer}>
          <button style={styles.backButton} onClick={onBack}>
            ← Back to Portal
          </button>
          <h1 style={styles.headerTitle}>Archived Students</h1>
          <p style={styles.headerSubtitle}>Previously enrolled students - {archivedStudents.length} total</p>
        </div>
      </div>

      <div style={styles.centerContainer}>
        {/* Info Card */}
        <div style={{
          ...styles.card,
          backgroundColor: '#f0f9ff',
          border: '2px solid #bfdbfe',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: 0, color: '#1e40af', fontSize: '0.9375rem' }}>
            ℹ️ Archived students are kept for records but don't appear in active rosters. You can restore them at any time.
          </p>
        </div>

        {/* Students Table */}
        <div style={styles.card}>
          <h2 style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Archive style={{ width: '20px', height: '20px', color: '#6b7280' }} />
            All Archived Students ({archivedStudents.length})
          </h2>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e5e7eb' }}>
                  <th style={{ padding: '1rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Student</th>
                  <th style={{ padding: '1rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Grade</th>
                  <th style={{ padding: '1rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Program</th>
                  <th style={{ padding: '1rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Parent</th>
                  <th style={{ padding: '1rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Contact</th>
                  <th style={{ padding: '1rem', textAlign: 'left', fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Archived</th>
                  <th style={{ padding: '1rem', textAlign: 'center', fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {archivedStudents.map((student, index) => (
                  <tr key={student.id} style={{ 
                    borderBottom: '1px solid #f3f4f6', 
                    backgroundColor: index % 2 === 0 ? 'white' : '#f9fafb' 
                  }}>
                    <td style={{ padding: '1rem' }}>
                      <div style={{ fontWeight: '500', fontSize: '0.875rem' }}>
                        {student.firstName} {student.lastName}
                      </div>
                    </td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: '#6b7280' }}>
                      {student.grade || '-'}
                    </td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: '#6b7280' }}>
                      {student.programSelection || '-'}
                    </td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: '#6b7280' }}>
                      {student.parentName || '-'}
                    </td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem' }}>
                      <div style={{ color: '#6b7280' }}>{student.parentPhone || '-'}</div>
                      <div style={{ color: '#9ca3af', fontSize: '0.75rem' }}>{student.parentEmail || '-'}</div>
                    </td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: '#6b7280' }}>
                      {student.archivedDate ? 
                        new Date(student.archivedDate).toLocaleDateString() 
                        : '-'}
                    </td>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <button
                        style={{
                          ...styles.button,
                          padding: '0.5rem 1rem',
                          fontSize: '0.75rem',
                          backgroundColor: '#10b981'
                        }}
                        onClick={() => handleUnarchive(student.id, `${student.firstName} ${student.lastName}`)}
                      >
                        Restore
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {archivedStudents.length === 0 && (
              <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                <Archive style={{ width: '48px', height: '48px', color: '#d1d5db', margin: '0 auto 1rem auto' }} />
                <p style={{ color: '#6b7280' }}>No archived students</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchivedStudents;